<template>
    <div>
        <h2>Agenda Management</h2>
        <hr />
        <div class="d-flex justify-content-between mb-3">
            <div>
                <button v-if="selectedAgenda" class="btn btn-warning btn-sm me-2"
                    @click="editAgenda(selectedAgenda.id)">Edit</button>
                <button v-if="selectedAgenda" class="btn btn-danger btn-sm" @click="toggleAgenda(selectedAgenda.id)">
                    {{ selectedAgenda.is_active ? 'Disable' : 'Enable' }}
                </button>
            </div>
            <button class="btn btn-primary btn-sm" @click="createAgenda">Add Agenda</button>
        </div>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Title</th>
                        <th>Group</th>
                        <th>Description</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(agenda, index) in agendas" :key="agenda.id"
                        :class="{ 'bg-disabled': !agenda.is_active, 'table-active': selectedAgenda && selectedAgenda.id === agenda.id }"
                        @click="selectAgenda(agenda)">
                        <td>{{ index + 1 }}</td>
                        <td>{{ agenda.title }}</td>
                        <td>{{ agenda.group?.name }}</td>
                        <td>{{ agenda.description }}</td>
                        <td>
                            <span :class="{ 'text-success': agenda.is_active, 'text-danger': !agenda.is_active }">
                                {{ agenda.is_active ? 'Active' : 'Inactive' }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            agendas: [],
            selectedAgenda: null
        };
    },
    methods: {
        fetchAgendas() {
            this.$api.get('/agendas').then(response => {
                this.agendas = response.data;
            });
        },
        createAgenda() {
            this.$router.push('/dashboard/agendas/create');
        },
        editAgenda(id) {
            this.$router.push(`/dashboard/agendas/${id}/edit`);
        },
        toggleAgenda(id) {
            this.$api.post(`/agendas/${id}/toggle`).then(() => {
                this.fetchAgendas();
                this.selectedAgenda = null;
            });
        },
        selectAgenda(agenda) {
            this.selectedAgenda = this.selectedAgenda && this.selectedAgenda.id === agenda.id ? null : agenda;
        }
    },
    mounted() {
        this.fetchAgendas();
    }
};
</script>

<style>
.bg-disabled {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}

.table-active {
    background-color: #d1ecf1 !important;
}

.bg-disabled td {
    background-color: #f8d7da !important;
}
</style>